import { Injectable, Inject } from '@angular/core';
import { DispatchersFacadeService } from '../state-management/dispatchers-facade.service';
import {
  ProcedureInstanceLocalStorageDto,
  ProcedureInstanceLocalStorageService,
} from 'src/app/services/es-shared/es-local-storage/procedure-instance-local-storage.service';

@Injectable()
export class ProcedureInstanceListenersService {
  constructor(
    @Inject('dispatcherService')
    private dispatcher: DispatchersFacadeService,
    private procedureInstanceLocalStorageService: ProcedureInstanceLocalStorageService
  ) {
    this.subscribeToEvents();
  }

  private subscribeToEvents() {
    this.dispatcher.paymentGateway.observable$.subscribe((event) => {
      const instance: ProcedureInstanceLocalStorageDto = {
        procedureInstanceId: event.procedureInstanceId,
        procedureInstanceNumber: event.procedureInstanceNumber,
        serviceKey: event.serviceKey,
      };

      this.procedureInstanceLocalStorageService.save(
        event.procedureInstanceId,
        instance
      );
    });
  }
}
